import { AxiosPromise } from 'axios';
import { apiService } from '@app/services';

class VaultPasswordHistoryService {
    readonly apiBase: string = '/api/directory/Vaults';

    getVaultPasswordHistory(jsonObject: any, vaultId: string, handleSuccess: Function, handleError: Function): AxiosPromise {
        return apiService.post(`${this.apiBase}(${vaultId})/GetVaultPasswordHistory?$orderby=Created%20desc`,
            jsonObject,
            {
                onSuccess: handleSuccess,
                onError: handleError
            })
            .catch();
    };

    getVaultPasswordHistoryPassword(jsonObject: any, vaultId: string): AxiosPromise {
        return apiService.post(`${this.apiBase}(${vaultId})/GetVaultPasswordHistoryPassword`,
            jsonObject)
            .catch();
    };
}

export const vaultPasswordHistoryService = new VaultPasswordHistoryService();